<div class="pageWrapper">
    <router-outlet></router-outlet>
</div>
